module.exports = "/_next/static/images/8e28c2226ff84a89fd505f1826164707-row-2-transfer.svg";